
import React from 'react';
import { Helmet } from 'react-helmet';

export const SchemaMarkup = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Dentist",
    "name": "Asrani Dental Clinic",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Sadar Bazar, Nagpur",
      "addressLocality": "Nagpur",
      "postalCode": "440001",
      "addressCountry": "IN"
    },
    "areaServed": "Nagpur",
    "medicalSpecialty": ["Dentistry", "Pediatric Dentistry"],
    "url": "https://asranidental.com",
    "openingHours": "Mo-Sa 10:00-19:00",
    "telephone": "+918010224989",
    "image": "https://asranidental.com/assets/clinic.jpg",
    "priceRange": "₹₹",
    "sameAs": [
      "https://www.facebook.com/asranidental",
      "https://www.instagram.com/asranidental"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};
